var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: true, expression: "true" }
      ],
      staticClass: "flex sm10"
    },
    [
      _c(
        "FormFieldsContainer",
        { attrs: { titulo: "Devolver Serie " + _vm.data.serienumero } },
        [
          !_vm.loading
            ? _c(
                "v-form",
                { staticClass: "layout sm12 wrap" },
                [
                  _c(
                    "v-flex",
                    { attrs: { layout: "", sm12: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", sm6: "" } },
                        [
                          _c("v-combobox", {
                            attrs: {
                              label: "Motivo de Devolución (Obligatorio)",
                              disabled: _vm.disabledForm,
                              items: _vm.statusList,
                              "item-text": "val",
                              "item-value": "serieactiva_motivoid",
                              rules: [_vm.rules.motivo],
                              required: ""
                            },
                            on: { change: _vm.handleSend },
                            model: {
                              value: _vm.objParam.motivo,
                              callback: function($$v) {
                                _vm.$set(_vm.objParam, "motivo", $$v)
                              },
                              expression: "objParam.motivo"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm12: "" } },
                        [
                          _c("v-textarea", {
                            attrs: {
                              label: "Descripción (Obligatorio)",
                              counter: 350,
                              disabled: _vm.disabledForm,
                              max: "350",
                              rules: [_vm.rules.descripcion],
                              required: ""
                            },
                            on: { input: _vm.handleSend },
                            model: {
                              value: _vm.objParam.serieactiva_motivoobs,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.objParam,
                                  "serieactiva_motivoobs",
                                  $$v
                                )
                              },
                              expression: "objParam.serieactiva_motivoobs"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c("v-flex", { attrs: { md12: "", sm12: "" } }, [
                    _c("div", { staticClass: "text-sm-center layout" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-top": "6px",
                            "padding-right": "0px"
                          },
                          attrs: { align: "right" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticStyle: {
                                "padding-right": "20px",
                                "background-color": "#ff6c00!important",
                                width: "135px"
                              },
                              attrs: {
                                disabled:
                                  _vm.disabledForm || _vm.disabledFiled.btnSave
                              },
                              on: { click: _vm.handleReturnSerie }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: { color: "white" },
                                  attrs: { dark: "", left: "" }
                                },
                                [_vm._v("save")]
                              ),
                              _c("span", { staticStyle: { color: "white" } }, [
                                _vm._v("Guardar")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "padding-top": "6px",
                            "padding-right": "0px"
                          },
                          attrs: { align: "right" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticStyle: {
                                "padding-right": "20px",
                                color: "#27488e!important",
                                width: "135px"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.closeModal({})
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticStyle: { color: "black" },
                                  attrs: { dark: "", left: "" }
                                },
                                [_vm._v("undo")]
                              ),
                              _c("span", { staticStyle: { color: "black" } }, [
                                _vm._v("Volver")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ])
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }